import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumTranslate'
})
export class EnumTranslatePipe implements PipeTransform {

  constructor() {}

  transform(value: string | number | boolean | null | undefined, type?: 'Audit' | 'Review'): string {
    if (value === null || value === undefined || value === '' || value == -1) {
      return '----';
    }

    if (typeof value === 'boolean') {

      if (type === 'Audit') {
        return value ? 'ENUMS.Audited' : 'ENUMS.NotAudited';
      }

      if (type === 'Review') {
        return value ? 'ENUMS.Reviewed' : 'ENUMS.NotReviewed';
      }
    }

    return `ENUMS.${value}`;
  }

}
